import {PayloadStates} from '@lore/utils';
import useMissingFields from '@/pages/events/useMissingFields';
import isEventShareable from '@/features/share-event/utils/isEventShareable';

// Same rules as the Share event button on the event card.
export default function useIsEventShareable(event) {
  const {missingFields} = useMissingFields(event);

  const isIncomplete = (
    missingFields.state !== PayloadStates.RESOLVED ||
    missingFields.data.length > 0
  );

  return isEventShareable(event.data, {isIncomplete});
}
